import React from 'react';
import './NoticeBoard.css';

function NoticeBoard({ notices, onSelectNotice, selectedNotice }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="notice-board">
      <h2 className="board-title">전자공고 목록</h2>
      <div className="notice-list">
        <table className="notice-table">
          <thead>
            <tr>
              <th>번호</th>
              <th>구분</th>
              <th>제목</th>
              <th>공고일</th>
              <th>최종수정일</th>
            </tr>
          </thead>
          <tbody>
            {notices.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">등록된 공고가 없습니다.</td>
              </tr>
            ) : (
              notices.map((notice, index) => (
                <tr 
                  key={notice.id} 
                  onClick={() => onSelectNotice(notice)}
                  className={selectedNotice?.id === notice.id ? 'selected' : ''}
                >
                  <td>{notices.length - index}</td>
                  <td className="category">{notice.category}</td>
                  <td className="title">{notice.title}</td>
                  <td>{formatDate(notice.date)}</td>
                  <td>{formatDate(notice.lastModified)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default NoticeBoard;